import { render, staticRenderFns } from "./ProjectBuyerStatisticsReport.vue?vue&type=template&id=37fa2932&"
import script from "./ProjectBuyerStatisticsReport.vue?vue&type=script&lang=ts&"
export * from "./ProjectBuyerStatisticsReport.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBuyerStatisticsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports